import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  Loader,
  LoadingOverlay,
  Select,
  Text,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useDebouncedState, useDisclosure, useHotkeys } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconBinaryTree,
  IconCalendar,
  IconFileExport,
  IconFileInvoice,
  IconPrinter,
  IconRefresh,
  IconSearch,
  IconStatusChange,
  IconTransferIn,
  IconTransferOut,
  IconTruckDelivery,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useDeferredValue, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useLocation, useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import {
  repositoryDelivery,
  repositoryMdm,
} from "../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import {
  changeSearchValue,
  getValueById,
} from "../../../_base/helper/FunctionHelper";
import { _localization } from "../../../config/location";
import { green } from "../../../const/variables";
import { MessageResponse } from "../../../model/MessageResponse";
import ConfirmInfoGHTKRequestTransfer from "./ConfirmInfoGHTKRequestTransfer";
import { printGhtkLabel } from "./printGhtkLabel";
import TransferShippingFromInv from "./TransferShippingFromInv";
import { useTableFillScreen } from "./useTableFillScreen";

type ColumnPinningType = {
  left?: string[];
  right?: string[];
};

const RequestTransferExpress = ({ toolbar }: { toolbar: HTMLElement | null }) => {
  const [data, setData] = useState<any[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });
  const rowSelectionDeferred =
    useDeferredValue<MRT_RowSelectionState>(rowSelection);
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [visible, { toggle, open, close }] = useDisclosure(false);

  const navigate = useNavigate();
  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";
  const [search, setSearch] = useState<any>({
    FromCreateDate:
      _searchJson && _searchJson.FromCreateDate && checkedPinSearch
        ? new Date(_searchJson.FromCreateDate)
        : new Date(
            new Date(new Date().setMonth(new Date().getMonth() - 1)).getTime() +
              7 * 60 * 60 * 1000,
          )?.toISOString(),
    ToCreateDate:
      _searchJson && _searchJson.ToCreateDate && checkedPinSearch
        ? new Date(_searchJson.ToCreateDate)
        : new Date(new Date().getTime() + 7 * 60 * 60 * 1000).toISOString(),
    StatusCode:
      _searchJson && _searchJson.StatusCode && checkedPinSearch
        ? _searchJson.StatusCode
        : "",
    Type:
      _searchJson && _searchJson.Type && checkedPinSearch
        ? _searchJson.Type
        : "",
    FromBranchId:
      _searchJson && _searchJson.FromBranchId && checkedPinSearch
        ? _searchJson.FromBranchId
        : "",
    ToBranchId:
      _searchJson && _searchJson.ToBranchId && checkedPinSearch
        ? _searchJson.ToBranchId
        : "",
  });
  const [keySearch, setKeySearch] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
    300,
  );

  const dataRequestTransferStatusOption = [
    {
      value: "PHIEU_TAO_MOI",
      label: "Phiếu tạo mới",
    },
    {
      value: "XUAT_KHO",
      label: "Xuất kho",
    },
    {
      value: "NHAP_KHO",
      label: "Nhập kho",
    },
    {
      value: "KHOA",
      label: "Khóa",
    },
    {
      value: "HOAN_THANH",
      label: "Hoàn thành",
    },
    {
      value: "DONG_YEU_CAU",
      label: "Đóng yêu cầu",
    },
  ];

  const dataTblInventoryTransactionType = [
    {
      label: "Điều chuyển chi nhánh",
      value: "DIEU_CHUYEN_CHI_NHANH",
    },
    {
      label: "Điều chuyển chi nhánh serial",
      value: "DIEU_CHUYEN_CHI_NHANH_SERIAL",
    },
  ];

  const dataTransferShipping = [
    { label: "GHTK", value: "GHTK" },
    { label: "Nhất Tín", value: "NHAT_TIN" },
    { label: "Tín Thành", value: "TIN_THANH" },
    { label: "Nasco", value: "NASCO" },
    { label: "Viettel", value: "VIETTEL" },
    { label: "Khác", value: "KHAC" },
  ];

  const [dataBranch, setDataBranch] = useState<any[]>([]);

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "code",
        header: "Số phiếu YCDC",
        Cell: ({ renderedCellValue, row }) => (
          <Tooltip label="Xem chi tiết">
            <Badge
              radius="sm"
              variant="dot"
              size="lg"
              style={{ cursor: "pointer" }}
              color={renderedCellValue === null ? "red" : green.base}
              onDoubleClick={() => detailItem(row.original.id)}
            >
              {renderedCellValue === null
                ? "Không xác định"
                : renderedCellValue}
            </Badge>
          </Tooltip>
        ),
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "statusCode",
        header: "Trạng thái",
        Cell: ({ renderedCellValue }) => (
          <>
            <Badge color={getColorStatus(renderedCellValue)}>
              {getValueById(
                String(renderedCellValue || ""),
                dataRequestTransferStatusOption,
                "label",
              )}
            </Badge>
          </>
        ),
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "type",
        header: "Loại phiếu",
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
        size: 250,
        Cell: ({ row }) => (
          <Badge
            color={getColorType(row.original.type ?? null)}
            variant="light"
            bd={`1px solid ${getColorType(row.original.type ?? null)}`}
          >
            {getValueById(
              row.original.type?.toString() ?? null,
              dataTblInventoryTransactionType,
              "label",
            )}
          </Badge>
        ),
      },
      {
        accessorKey: "fromBranchName",
        header: "Chi nhánh xuất",
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "fromInvName",
        header: "Kho xuất",
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ renderedCellValue, row }) => (
          <Text size="12.5px" fw={500}>
            {row.original.fromInvCode} - {renderedCellValue}
          </Text>
        ),
        size: 225,
      },
      {
        accessorKey: "toBranchName",
        header: "Chi nhánh nhận",
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "toInvName",
        header: "Kho nhận",
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ renderedCellValue, row }) => (
          <Text size="12.5px" fw={500}>
            {[row.original.toInvCode, renderedCellValue]
              .filter((i) => i && String(i).length > 0)
              .join(" - ")}
          </Text>
        ),
        size: 225,
      },
      {
        accessorKey: "attribute16",
        header: "Trạng thái đẩy đơn",
        size: 225,
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ renderedCellValue, row }) =>
          row.original.attribute1 === "KHO" ? (
            <Badge
              color={
                renderedCellValue && String(renderedCellValue).includes("Fail")
                  ? "red"
                  : renderedCellValue &&
                      !String(renderedCellValue).includes("Fail")
                    ? "green"
                    : "gray"
              }
              variant="light"
            >
              {renderedCellValue && String(renderedCellValue).includes("Fail")
                ? "Đơn đẩy lỗi"
                : renderedCellValue &&
                    !String(renderedCellValue).includes("Fail")
                  ? "Đã đẩy"
                  : "Chưa đẩy"}
            </Badge>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "attribute17",
        header: "Đơn vị vận chuyển",
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ renderedCellValue, row }) =>
          row.original.attribute16 ? (
            <Badge
              color={getColorTransfer(renderedCellValue?.toString() ?? "")}
            >
              {getValueById(
                renderedCellValue?.toString() ?? "",
                dataTransferShipping,
                "label",
              ).length > 0
                ? getValueById(
                    renderedCellValue?.toString() ?? "",
                    dataTransferShipping,
                    "label",
                  )
                : renderedCellValue}
            </Badge>
          ) : (
            <Badge color="gray" variant="light">
              Chưa vận chuyển
            </Badge>
          ),
      },
      {
        accessorKey: "attribute18",
        header: "Mã vận đơn",
        size: 250,
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Badge
              radius="sm"
              variant="dot"
              size="md"
              color={renderedCellValue === null ? "red" : "blue"}
            >
              {!renderedCellValue ? "Không có mã vận đơn" : renderedCellValue}
            </Badge>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "attribute19",
        header: "Trạng thái đẩy đơn COD",
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ renderedCellValue }) => (
          <Badge color={renderedCellValue === "DA_DONG_GOI" ? "teal" : "gray"}>
            {renderedCellValue === "DA_DONG_GOI"
              ? "Đã đóng gói"
              : "Chưa đóng gói"}
          </Badge>
        ),
      },
      {
        accessorKey: "attribute20",
        header: "Ghi chú",
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableSorting: false,
        enableColumnFilter: false,
        enableColumnActions: false,
        size: 95,
        Cell: ({ row }) => (
          <Flex justify={"start"} align={"center"} gap={"xs"}>
            {row.original.attribute17 && row.original.attribute17 !== "GHTK" ? (
              <></>
            ) : row.original.attribute17 === "GHTK" &&
              row.original.attribute16 &&
              String(row.original.attribute16).length > 0 &&
              !String(row.original.attribute16).includes("Fail") ? (
              <>
                <Tooltip label="Thông tin giao vận">
                  <ActionIcon
                    color="blue"
                    variant="light"
                    onClick={() => {
                      window.open(
                        `https://i.ghtk.vn/${row.original.attribute16}`,
                        "_blank",
                      );
                    }}
                  >
                    <IconFileExport size={20} stroke={1.5} />
                  </ActionIcon>
                </Tooltip>
                <Tooltip label="In nhãn GHTK">
                  <ActionIcon
                    color="indigo"
                    variant="light"
                    aria-label="In nhãn GHTK"
                    onClick={() => printGhtkLabel(row.original.code)}
                  >
                    <IconPrinter size={20} stroke={1.5} />
                  </ActionIcon>
                </Tooltip>
              </>
            ) : (
              <>
                <Tooltip label="Đẩy đơn GHTK">
                  <ActionIcon
                    variant="light"
                    color="green"
                    disabled={row.original.statusCode !== "XUAT_KHO"}
                    onClick={() => modalsConfirmInfo(row.original.id)}
                  >
                    <IconTruckDelivery size={20} stroke={1.5} />
                  </ActionIcon>
                </Tooltip>
                <Tooltip label="Đơn vị vận chuyển khác">
                  <ActionIcon
                    variant="light"
                    color="orange"
                    disabled={row.original.statusCode !== "XUAT_KHO"}
                    onClick={() => modalsTransferShippingFromInv(row.original)}
                  >
                    <IconBinaryTree size={20} stroke={1.5} />
                  </ActionIcon>
                </Tooltip>
              </>
            )}
          </Flex>
        ),
      },
    ],
    [
      dataRequestTransferStatusOption,
      dataTransferShipping,
      dataTblInventoryTransactionType,
    ],
  );

  const getColorStatus = (text: any) => {
    switch (text) {
      case "XUAT_KHO":
        return "#87de57";
      case "NHAP_KHO":
        return "teal";
      case "PHIEU_TAO_MOI":
        return "blue";
      case "KHOA":
        return "red";
      case "HOAN_THANH":
        return "green";
      case "DONG_YEU_CAU":
        return "gray";
      case "QUAN_LY_TU_CHOI":
      case "DPV_TU_CHOI":
        return "red";
      case null:
        return "rgba(0, 0, 0, 0)";
      default:
        return "gray";
    }
  };

  const getColorTransfer = (value: string) => {
    switch (value) {
      case "GHTK":
        return "#00EE36";
      case "NHAT_TIN":
        return "#FFD800";
      case "TIN_THANH":
        return "linear-gradient(90deg, #AA1015 0%, #8E9093 100%)";
      case "NASCO":
        return "linear-gradient(90deg, #FB3D49 0%, #D12D79 100%)";
      case "VIETTEL":
        return "#E30B29";
      case null:
      case "":
      case undefined:
        return "rgba(0, 0, 0, 0)";
      default:
        return "blue";
    }
  };

  const getColorType = (type: string | null) => {
    switch (type) {
      case "DIEU_CHUYEN_CHI_NHANH":
        return "#f06418";
      case "DIEU_CHUYEN_CHI_NHANH_SERIAL":
        return "#ffab09";
      case null:
        return "rgba(0, 0, 0, 0)";
      case "NOI_BO":
        return "#656a7e";
    }
  };

  const detailItem = (id: string | number) => {
    navigate("/warehouse-config/detail-request-transfer", {
      state: { id: id },
    });
  };

  const modalsConfirmInfo = (id: number) => {
    modals.openConfirmModal({
      title: <Title order={5}>Xác nhận thông tin !</Title>,
      size: "80vw",
      children: (
        <ConfirmInfoGHTKRequestTransfer
          id={id}
          dataBranch={dataBranch}
          onSuccess={fetchData}
          isCOD={true}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const modalsTransferShippingFromInv = (data: any) => {
    modals.openConfirmModal({
      title: <Title order={5}>Điều chuyển giao vận</Title>,
      size: "auto",
      children: (
        <TransferShippingFromInv
          onSuccess={fetchData}
          dataRequestTransfer={data}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const fetchData = async (exportExcel?: boolean) => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    try {
      let url = `/api/v1/TblRequestTransfer/get-list?Skip=${
        pagination.pageIndex * pagination.pageSize
      }&Take=${pagination.pageSize}${
        search.Type && String(search.Type)?.length > 0
          ? ""
          : "&Types=DIEU_CHUYEN_CHI_NHANH&Types=DIEU_CHUYEN_CHI_NHANH_SERIAL&Types=XUAT_HUY&Types=XUAT_DIEU_CHINH&Types=XUAT_CONG_CU_DUNG_CU"
      }&DeliveryCode=KHO`;

      const params = new URLSearchParams();
      Object.entries(search).forEach(([key, value]) => {
        if (Array.isArray(value) && value?.length > 0) {
          value.forEach((item) => params.append(key, String(item)));
        } else if (typeof value === "string" && value?.length > 0) {
          params.append(key, value);
        }
      });

      if (keySearch?.length > 0) {
        url += `&KeySearch=${keySearch?.trim()}`;
      }

      url += `&${params?.toString()}`;

      const res = await repositoryMdm.get<MessageResponse<any>>(url);

      if (res && res.success) {
        const result = res.data;
        setData(result);
        setRowCount(res.totalCount);

        if (exportExcel && !res?.totalCount) {
          NotificationExtension.Fails(
            "Export Excel thất bại, vui lòng liên hệ phòng CNTT !",
          );
        } else if (exportExcel && res?.totalCount > 0) {
          handleExport(res?.totalCount);
        }
      } else {
        setData([]);
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify({
          ...search,
          keySearch: keySearch,
        }),
      );
    }
  };

  const handleExport = async (totalCount: number) => {
    open();
    try {
      let url = `/api/v1/TblRequestTransfer/get-list?Skip=0&Take=${totalCount}${
        search.Type && String(search.Type)?.length > 0
          ? ""
          : "&Types=DIEU_CHUYEN_CHI_NHANH&Types=DIEU_CHUYEN_CHI_NHANH_SERIAL&Types=XUAT_HUY&Types=XUAT_DIEU_CHINH&Types=XUAT_CONG_CU_DUNG_CU"
      }&DeliveryCode=KHO`;

      const params = new URLSearchParams();
      Object.entries(search).forEach(([key, value]) => {
        if (Array.isArray(value) && value?.length > 0) {
          value.forEach((item) => params.append(key, String(item)));
        } else if (typeof value === "string" && value?.length > 0) {
          params.append(key, value);
        }
      });

      if (keySearch?.length > 0) {
        url += `&KeySearch=${keySearch?.trim()}`;
      }

      url += `&${params?.toString()}`;

      const res = await repositoryMdm.get<MessageResponse<any>>(url);

      if (res && res.success) {
        const dataAPI = res.data || [];
        const dataExport = dataAPI.map((i: any) => ({
          "Số phiếu YCDC": i.code || "",
          "Trạng thái":
            getValueById(
              String(i.statusCode),
              dataRequestTransferStatusOption,
              "label",
            ) || "",
          "Loại phiếu":
            getValueById(i.type, dataTblInventoryTransactionType, "label") ||
            "",
          "Chi nhánh xuất": i.fromBranchName || "",
          "Kho xuất":
            `${[i.fromInvCode, i.fromInvName].filter((i) => i && String(i).length > 0).join(" - ")}` ||
            "",
          "Chi nhánh nhận": i.toInvName || "",
          "Kho nhận":
            `${[i.toInvCode, i.toInvName].filter((i) => i && String(i).length > 0).join(" - ")}` ||
            "",
          "Trạng thái đẩy đơn":
            i.attribute16 &&
            String(i.attribute16).length > 0 &&
            String(i.attribute16).includes("Fail")
              ? "Đẩy đơn lỗi"
              : i.attribute16 && !String(i.attribute16).includes("Fail")
                ? "Đã đẩy"
                : "Chưa đẩy",
          "Đơn vị vận chuyển":
            i.attribute16 && String(i.attribute16).length > 0
              ? getValueById(i.attribute17, dataTransferShipping, "label") ||
                i.attribute17
              : "Chưa vận chuyển",
          "Mã vận đơn": i.attribute18 || "Không có mã vận đơn",
          "Trạng thái đẩy đơn COD":
            i.attribute19 === "DA_DONG_GOI" ? "Đã đóng gói" : "Chưa đóng gói",
          "Ghi chú": i.attribute20 || "",
        }));

        const worksheet = XLSX.utils.json_to_sheet(dataExport);

        const objectMaxLength: any[] = [];
        dataExport.forEach((row: any) => {
          Object.keys(row).forEach((key, index) => {
            const headerLen = key ? key.toString().length : 0;
            const valueLen = row[key] ? row[key].toString().length : 0;
            const maxLen = Math.max(headerLen, valueLen);

            objectMaxLength[index] = Math.max(
              objectMaxLength[index] || 0,
              maxLen,
            );
          });
        });

        worksheet["!cols"] = objectMaxLength.map((w) => ({ wch: w + 5 }));

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Báo cáo KHO YCDC");
        XLSX.writeFile(workbook, "Bao_cao_KHO_YCDC.xlsx");
      }
    } catch (error) {
      console.error("Error fetching GHTK orders:", error);
    } finally {
      close();
    }
  };

  const getDataBranch = async () => {
    const res = await repositoryDelivery.get<MessageResponse<any>>(
      "/api/v1/TblDmMasterOrg/get-all",
    );

    if (res && res.success) {
      const data = res.data.filter((i: any) => i.id && i.name);
      setDataBranch(data);
    }
  };

  useEffect(() => {
    fetchData();
  }, [pagination?.pageIndex, pagination?.pageSize]);

  useEffect(() => {
    getDataBranch();
  }, []);

  const getColumnPinningStorage = () => {
    const columnPinningStorage = localStorage.getItem(
      "columnPinningRequestTransferExpress",
    );
    return columnPinningStorage
      ? JSON.parse(columnPinningStorage)
      : {
          left: ["mrt-row-numbers", "code"],
          right: ["action"],
        }; // Giá trị mặc định
  };

  // Lưu columnPinning vào state
  const [columnPinning, setColumnPinning] = useState<ColumnPinningType>(
    getColumnPinningStorage(),
  );
  // Hàm lưu vào localStorage
  useEffect(() => {
    localStorage.setItem(
      "columnPinningRequestTransferExpress",
      JSON.stringify(columnPinning),
    );
  }, [columnPinning]);

  useEffect(() => {
    //   startTransition(() => {
    const valuesList = Object.keys(rowSelectionDeferred);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelectionDeferred);
      setSelectIds(valuesList);
    }
    //  });
  }, [rowSelectionDeferred]);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: false,
    positionToolbarAlertBanner: "bottom",
    enableRowNumbers: true,
    //add custom action buttons to top-left of top toolbar
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: false,
    getRowId: (row) => row.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        // left: ["mrt-row-numbers", "maVt"],
        // right: ["action"],
        ...columnPinning,
      },
      columnVisibility: { id: true, phone: false, fax: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    manualPagination: true,
    onColumnPinningChange: (newState) => {
      setColumnPinning(newState);
    },
    onRowSelectionChange: setRowSelection,
    rowCount: rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "500", //conditional styling
        fontSize: "12.5px",
        padding: "18px 15px",
      },
    }),
    state: {
      isLoading,
      pagination: pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      rowSelection,
      columnPinning,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
      highlightOnHover: true,
      withTableBorder: true,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      style: {
        cursor: "pointer",
        backgroundColor: row.index % 2 === 0 ? "#f8f9fa" : "white",
      },
    }),
  });

  // Chân bảng sát đáy màn hình
  useTableFillScreen(table, setHeight);

  useHotkeys([
    [
      "Enter",
      () => {
        fetchData();
      },
    ],
  ]);

  return (
    <>
      <div
        style={{
          width: "100%",
          overflowX: "hidden",
        }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 5 }}
          loaderProps={{
            children: (
              <Flex direction={"column"} align="center" gap="xs">
                <Loader type="dots" size={35}></Loader>
                {/* <Title size={15}> Đang upload tài liệu...</Title> */}
                <Title size={15}> Đang xử lý....</Title>
              </Flex>
            ),
          }}
        />
        <Grid mt={10} style={{ overflow: "hidden" }} gutter={8}>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Nhập từ khóa tìm kiếm"
              defaultValue={keySearch}
              onChange={(e) => setKeySearch(e.currentTarget.value)}
              leftSection={<IconSearch color="#15aabf" />}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày bắt đầu"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              clearable
              value={
                search.FromCreateDate && search.FromCreateDate?.length > 0
                  ? new Date(search.FromCreateDate ?? "")
                  : null
              }
              maxDate={
                search.ToCreateDate && search.ToCreateDate?.length > 0
                  ? new Date(search.ToCreateDate)
                  : new Date()
              }
              onChange={(e) => {
                changeSearchValue(
                  e
                    ? new Date(
                        new Date(e).getTime() + 7 * 3600 * 1000,
                      )?.toISOString()
                    : "",
                  "FromCreateDate",
                  setSearch,
                );
              }}
              leftSection={<IconCalendar color="#15aabf" />}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày kết thúc"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              clearable
              value={
                search.ToCreateDate && search.ToCreateDate?.length > 0
                  ? new Date(search.ToCreateDate ?? "")
                  : null
              }
              minDate={
                search.FromCreateDate && search.FromCreateDate?.length > 0
                  ? new Date(search.FromCreateDate)
                  : undefined
              }
              onChange={(e) => {
                changeSearchValue(
                  e
                    ? new Date(
                        new Date(e).getTime() + 7 * 3600 * 1000,
                      )?.toISOString()
                    : "",
                  "ToCreateDate",
                  setSearch,
                );
              }}
              leftSection={<IconCalendar color="#15aabf" />}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Select
              placeholder="Chi nhánh xuất"
              searchable
              clearable
              data={dataBranch.map((i) => ({
                label: `${i.code} - ${i.name}`,
                value: String(i.id),
              }))}
              leftSection={<IconTransferOut color="#15aabf" />}
              value={search.FromBranchId || null}
              onChange={(e) =>
                changeSearchValue(e ? e : "", "FromBranchId", setSearch)
              }
              nothingFoundMessage="Không tìm thấy dữ liệu !"
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Select
              placeholder="Chi nhánh nhập"
              searchable
              clearable
              data={dataBranch.map((i) => ({
                label: `${i.code} - ${i.name}`,
                value: String(i.id),
              }))}
              leftSection={<IconTransferIn color="#15aabf" />}
              value={search.ToBranchId || null}
              onChange={(e) =>
                changeSearchValue(e ? e : "", "ToBranchId", setSearch)
              }
              nothingFoundMessage="Không tìm thấy dữ liệu !"
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Select
              placeholder={"Trạng thái phiếu"}
              clearable
              leftSection={<IconStatusChange color="#15aabf" />}
              data={dataRequestTransferStatusOption}
              value={search.StatusCode || null}
              onChange={(e) =>
                changeSearchValue(e ? e : "", "StatusCode", setSearch)
              }
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Select
              placeholder="Loại phiếu"
              clearable
              leftSection={<IconFileInvoice color="#15aabf" />}
              data={dataTblInventoryTransactionType}
              value={search.Type || null}
              onChange={(e) => changeSearchValue(e ? e : "", "Type", setSearch)}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Button
              onClick={() => fetchData()}
              leftSection={<IconSearch size={14} />}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
      {/* Nút nằm trên hàng breadcrumb của ListTabCOD */}
      {toolbar &&
        createPortal(
          <Flex gap={"xs"}>
            <Button
              leftSection={<IconRefresh size={16} />}
              onClick={() => fetchData()}
              loading={isLoading}
            >
              Làm mới
            </Button>
            <Button
              leftSection={<IconFileExport size={16} />}
              onClick={() => fetchData(true)}
            >
              Export Excel
            </Button>
          </Flex>,
          toolbar,
        )}
      <Box mt={20}>
        <MantineReactTable table={table} />
      </Box>
    </>
  );
};

export default RequestTransferExpress;
